import { flattenObject } from './collection'

export function toCurrency(amount, decimals = 2) {
	return `$${parseFloat(amount).toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
}

export function toCapitalized(text, { delimiter = ' ', finalDelimiter = ' ' } = {}) {
	return text
		.split(delimiter)
		.map(word => `${word.substr(0, 1).toUpperCase()}${word.substr(1)}`)
		.join(finalDelimiter)
}

export function toQueryString(parameters) {
	if (!parameters || !Object.keys(parameters).length) { return '' }

	return `?${Object.keys(parameters).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`)
		.join('&')}`
}

export function toHex(number) {
	return Math.round(number).toString(16).padStart(2, '0')
}

export function isObjectId(objectId) {
	return /[a-f0-9]{24}/.test(objectId)
}

export function objectIdToTimestamp(objectId) {
	return parseInt(objectId.substring(0, 8), 16) * 1000
}

export function jsonToCsv(jsonArray, { hasHeader = true } = {}) {
	let rowLength = 0
	return jsonArray.reduce((acc, entry) => {
		const flattenedEntry = flattenObject(entry)
		if (hasHeader) {
			if (!acc.length) {
				acc.push(Object.keys(flattenedEntry))
			} else {
				Object.keys(flattenedEntry).forEach((key) => {
					if (acc[0].indexOf(key) === -1) {
						acc[0].push(key)
					}
				})
			}
			rowLength = acc[0].length
			acc.push(acc[0].map(key => (typeof flattenedEntry[key] === 'undefined' || flattenedEntry[key] === null
				? '' : flattenedEntry[key].toString())))
			return acc
		}

		if (rowLength < Object.keys(flattenedEntry).length) {
			rowLength = Object.keys(flattenedEntry).length
		}
		acc.push(Object.values(flattenedEntry).map(value => (typeof value === 'undefined' || value === null ? '' : value.toString())))
		return acc
	}, []).map((row) => {
		const formattedRow = row.map(cell => (cell === '' ? cell : `"${cell.replace(/"/g, '""')}"`))
		if (row.length < rowLength) {
			for (let i = row.length; i < rowLength; ++i) {
				formattedRow.push('')
			}
		}
		return formattedRow.join(',')
	}).join('\n')
}
